module.exports = __webpack_public_path__ + "static/flasche-orion-medium-10265a972008dc4a0e91e5a8f99f25ea.png";